module.exports = __webpack_public_path__ + "img/Gallery_2_02.2e20e42f.jpeg";